/** Флаги функций, которые включаются по мере готовности. */
export const FEATURES = {
  /** Раздел «Посты» — этап 2. */
  posts: false,
  /** Тёмная тема. До перевода всех страниц включена только локально (VITE_DARK_THEME=on). */
  darkTheme: import.meta.env.VITE_DARK_THEME === 'on',
} as const

export type FeatureName = keyof typeof FEATURES
